export 	function farloUiMcSignup(_sel) {
    let farloUiSignupForm = null;
    if (typeof _sel.target !== 'undefined' && _sel.target !== null) {
        if (_sel.target.dataset.crmButtonFor !== '') {
            farloUiSignupForm = new FarloUiMc(_sel.target.dataset.crmButtonFor);
        }
    } else if (farloUiSignupForm) {
        farloUiSignupForm.toggleForm();
    } else {
        farloUiSignupForm = new FarloUiMc(_sel.id);
    }

    let form = document.getElementById('site-farlo-ui-crm-landing-signup');
    if (form) {
        new FarloUiMc(form.id); 
    }


}